import { Card, CardHeader, CardTitle, CardContent } from '../ui/card';

const AdminStatsCard = ({ title, value, icon: Icon, iconColor = 'text-gray-600', valueColor = 'text-cyan-600' }) => {
  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between pb-2">
        <CardTitle className="text-sm font-medium text-gray-600">{title}</CardTitle>
        <Icon className={`w-4 h-4 ${iconColor}`} />
      </CardHeader>
      <CardContent>
        <div className={`text-3xl font-bold ${valueColor}`}>{value}</div>
      </CardContent>
    </Card>
  );
};

export default AdminStatsCard;
